import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PROJECTS } from "../../../Api/Api";
import { Box, Skeleton, Typography } from "@mui/material";
import { Axios } from "../../../Api/axios";
import Cookie from "cookie-universal";
import Grid from "@mui/material/Grid2";
import { PageContainer } from "@toolpad/core";

export default function ProjectDetail() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const cookie = Cookie();
  const token = cookie.get("dashboardLogin");

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await Axios.get(`/panel/${PROJECTS}/${id}`);
        setProject(response.data);
      } catch (error) {
        console.error("Error fetching project details:", error);
      }
    };

    fetchProject();
  }, [id]);

  if (!project) {
    return <Typography>Loading...</Typography>;
  }

  // Separate background image and other images
  const backgroundImage = project.images?.find((img) => img.is_background);
  const otherImages = project.images?.filter((img) => !img.is_background);

  return (
    <>
      {/* Project Details */}
      <PageContainer>
        <Grid container spacing={1}>
          <Grid size={12}>
            <Typography variant="h4">Title En: {project.title_en}</Typography>
            <Typography variant="body1">
              Description EN: {project.desc_en}
            </Typography>
            <Typography variant="body1">Slug En: {project.slug_en}</Typography>
            <Typography variant="h4">Title Ar: {project.title_ar}</Typography>
            <Typography variant="body1">
              Description Ar: {project.desc_ar}
            </Typography>
            <Typography variant="body1">Slug Ar: {project.slug_ar}</Typography>
            <Typography variant="body1">
              Client: {project.client.title_en}
            </Typography>
            <Typography variant="body1">Tag: {project.tag.name_en}</Typography>
            <Typography variant="body1">
              Start Date: {project.start_date}
            </Typography>
            <Typography variant="body1">url: {project.url}</Typography>
          </Grid>

          {/* Background Image */}
          {backgroundImage && (
            <Grid size={12}>
              <Typography variant="h6">Background Image</Typography>
              <Box
                component="img"
                src={backgroundImage.path}
                alt="Background"
                sx={{
                  width: "100%",
                  height: 200,
                  borderRadius: 2,
                  boxShadow: 2,
                  objectFit: "cover",
                }}
              />
            </Grid>
          )}

          {/* Project Images */}
          <Grid size={12}>
            <Typography variant="h6">Project Images</Typography>
            <Grid container spacing={1}>
              {otherImages && otherImages.length > 0 ? (
                otherImages.map((image, index) => (
                  <Grid size={3} key={index}>
                    <Box
                      component="img"
                      src={image.path}
                      alt={`Project Image ${index + 1}`}
                      sx={{
                        width: "100%",
                        height: 150,
                        borderRadius: 2,
                        boxShadow: 1,
                        objectFit: "cover",
                      }}
                    />
                  </Grid>
                ))
              ) : (
                <Typography>No project images available</Typography>
              )}
            </Grid>
          </Grid>
        </Grid>
      </PageContainer>
    </>
  );
}
